import { css } from "@emotion/react";

export const languageSelectionMenuStyles = {
  menuItem: css({
    width: "100%",
    textAlign: "left",
  }),
};
